import { BasePayload } from "./BasePayload";

export class UsuarioPlataformaPayload extends BasePayload {
  nombre: string = "";
  email: string = "";
  password?: string;
  isActivo: boolean = true;
  hasSuperAdmin: boolean = false;
  hasComercial: boolean = false;
  hasHardware: boolean = false;
  hasPilotos: boolean = false;
  hasConductores: boolean = false;
  hasOficina: boolean = false;
}
